import common from './common'
import calendar from './calendar'
import nav from './nav'
import signup from './signup'
import login from './login'
import auth from './auth'
import jobs from './jobs'
import profile from './profile'
import settings from './settings'
import wallet from './wallet'
import referrals from './referrals'
import messages from './messages'
import widget from './widget'
import community from './dao-community'

export default {
  common,
  calendar,
  signup,
  nav,
  login,
  auth,
  jobs,
  profile,
  settings,
  wallet,
  referrals,
  messages,
  widget,
  community
}



// WEBPACK FOOTER //
// ./src/i18n/es/index.js